import IngredientForm from './IngredientForm';

export default IngredientForm;
